import type { LucideIcon } from "lucide-react";
import type { Category } from "@/services/api/categories";
import { getLucideIcon } from "@/shared/lib/lucideIcons";
import { sortBy, comparators, type SortDirection } from "@/shared/lib/sortUtils";

export const iconMap: Record<string, LucideIcon> = {} as const;

export type SortField = "order" | "name" | "attributesCount";
export type { SortDirection };

export function getCategoryIcon(iconName?: string): LucideIcon | null {
  if (!iconName) return null;

  return getLucideIcon(iconName);
}

export function sortCategories(
  categories: Category[],
  sortField: SortField,
  sortDirection: SortDirection
): Category[] {
  return sortBy(categories, sortField, sortDirection, {
    order: comparators.number((category) => category.order ?? 999),
    name: comparators.string((category) => category.name),
    attributesCount: comparators.number(
      (category) => category.attributes?.length ?? category.attributesCount ?? 0
    ),
  });
}
